import { render, staticRenderFns } from "./DialogNumber.vue?vue&type=template&id=2b1da826&scoped=true&"
import script from "./DialogNumber.vue?vue&type=script&lang=js&"
export * from "./DialogNumber.vue?vue&type=script&lang=js&"
import style0 from "./DialogNumber.vue?vue&type=style&index=0&id=2b1da826&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1da826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VIcon,VRow})
